import { HEADER_CONTENT_TYPE } from 'constants/http';
import { JSON as JSON_MIME } from 'constants/mimes';
import {
  ORG_ROLE_CREATOR,
  ORG_ROLE_CREATOR_LITE,
  ORG_ROLE_VIEWER,
} from 'constants/organizationRoles';
import { VALIDATE_WORKSPACE_NAME_REGEX } from 'constants/regex';
import { getGraphQLClient } from 'utilities/graphql';
import * as sentry from 'utilities/sentry';

import AcceptWorkspaceInviteMutation from './AcceptOrgInvite.gql';
import updateSelectedWorkspace from './updateSelectedWorkspace.graphql';
import updateUserDefaultWorkspace from './updateUserDefaultWorkspace.graphql';

// NOTE: This actually sets the selected library - still using the old terminology
export const setWorkspace = async workspace => {
  try {
    await fetch('/v1/workspace', {
      method: 'POST',
      credentials: 'include',
      headers: { [HEADER_CONTENT_TYPE]: JSON_MIME },
      body: JSON.stringify({ workspace }),
    });
  } catch (e) {
    sentry.logException(e, 'unable to set workspace');
  }
};

export const goToWorkspace = async (workspaceId, path = '/team-videos') => {
  const client = getGraphQLClient();

  await client.mutate({
    mutation: updateSelectedWorkspace,
    variables: { workspaceId },
  });

  window.location.href = path;
};

export const requestAcceptWorkspaceInvite = token => {
  const gqlClient = getGraphQLClient();

  return gqlClient
    .mutate({
      mutation: AcceptWorkspaceInviteMutation,
      variables: {
        token,
      },
    })
    .then(({ data }) => {
      const { accepted } = data;

      return accepted;
    });
};

export const saveDefaultWorkspace = async selectedWorkspaceId => {
  const client = getGraphQLClient();

  const { data } = await client.mutate({
    mutation: updateUserDefaultWorkspace,
    variables: { workspaceId: selectedWorkspaceId },
  });

  if (data.updateUserDefaultWorkspace?.success) {
    return;
  }

  const { message } = data.UpdateDefaultWorkspace;

  throw new Error(message);
};

export const getDefaultRoleForMemberInvitations = ({ availableRoles }) => {
  const bestAvailableRole = [
    ORG_ROLE_CREATOR_LITE,
    ORG_ROLE_CREATOR,
    ORG_ROLE_VIEWER,
  ].find(role => availableRoles.some(r => r.value === role));

  return availableRoles.find(r => r.value === bestAvailableRole);
};

export const getDefaultRoleForSsoSettings = ({ availableRoles }) => {
  const bestAvailableRole = [ORG_ROLE_CREATOR_LITE, ORG_ROLE_CREATOR].find(
    role => availableRoles.some(r => r.value === role)
  );

  return availableRoles.find(r => r.value === bestAvailableRole);
};

export const isValidWorkspaceName = workspaceName => {
  if (!workspaceName || workspaceName.trim() === '') {
    return true;
  }

  return VALIDATE_WORKSPACE_NAME_REGEX.test(workspaceName);
};
